/**
 * Wishlist by Square beside ATC:
 * 1) Leave #vitals-wishlist for the app to mount a REAL button
 * 2) If the app injects below ATC (per app setting), move that node into the heart slot
 * 3) Show a toast after a successful click (do not block the app click)
 */
(function () {
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function wishlistUrl() {
    var link = document.querySelector(
      '#wishlist-teleport-target a[href*="wishlist"], header a[href*="wishlist"], a[href*="/apps/page/wishlist"]'
    );
    if (link && link.getAttribute('href')) return link.getAttribute('href');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if (root === '/') return '/apps/page/wishlist';
    return String(root).replace(/\/$/, '') + '/apps/page/wishlist';
  }

  function textOf(node) {
    return ((node && (node.innerText || node.textContent)) || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function isAdded(node) {
    return /added to wishlist|已加到願望|已加入收藏|已收藏|remove from wishlist/.test(textOf(node));
  }

  function isForbidden(node) {
    return !!(
      node &&
      node.closest(
        'header, .header, #wishlist-teleport-target, .menu-drawer, .product__media-item, media-gallery, .venn-gallery-modal'
      )
    );
  }

  function findLooseAppButton() {
    var roots = [
      document.querySelector('.product-form__buttons'),
      document.querySelector('product-form'),
      document.querySelector('.product__info-container')
    ].filter(Boolean);

    var found = null;
    roots.forEach(function (root) {
      if (found) return;
      root.querySelectorAll('button, a, [role="button"]').forEach(function (node) {
        if (found || isForbidden(node)) return;
        if (node.closest('#vitals-wishlist, .product-form__wishlist')) return;
        var t = textOf(node);
        if (/add to wishlist|added to wishlist|加到願望|已加到願望|加入收藏|已收藏/.test(t)) {
          found = node;
        }
      });
    });
    return found;
  }

  function showToast(added) {
    var old = document.querySelector('.vennassa-wishlist-toast');
    if (old) old.remove();

    var toast = document.createElement('div');
    toast.className = 'vennassa-wishlist-toast is-visible';
    toast.setAttribute('role', 'status');

    var msg = document.createElement('span');
    msg.textContent = added ? 'Saved to wishlist' : 'Removed from wishlist';

    var link = document.createElement('a');
    link.className = 'vennassa-wishlist-toast__link';
    link.href = wishlistUrl();
    link.textContent = 'View wishlist';

    toast.appendChild(msg);
    toast.appendChild(link);
    document.body.appendChild(toast);

    window.clearTimeout(showToast._t);
    showToast._t = window.setTimeout(function () {
      toast.classList.remove('is-visible');
      window.setTimeout(function () {
        toast.remove();
      }, 250);
    }, 4500);
  }

  function placeAppButton(slot) {
    var mount = slot.querySelector('#vitals-wishlist') || document.getElementById('vitals-wishlist');
    if (!mount) return null;

    if (!mount.childElementCount) {
      var loose = findLooseAppButton();
      if (loose) {
        var host =
          loose.closest('[class*="wishlist"], [class*="Wishlist"], [class*="Vtl"], [class*="vtl"]') || loose;
        if (!isForbidden(host) && !host.closest('#vitals-wishlist')) {
          mount.appendChild(host);
        }
      }
    }

    if (mount.childElementCount) {
      slot.classList.add('has-app-button');
      var control = mount.querySelector('button, a, [role="button"]') || mount.firstElementChild;
      slot.classList.toggle('is-active', !!(control && isAdded(control)));
      return control;
    }

    slot.classList.remove('has-app-button');
    return null;
  }

  function wire(slot) {
    if (!slot || slot.dataset.wlReady === 'true') return;
    slot.dataset.wlReady = 'true';

    // Capture click for toast only — never preventDefault on the app button
    slot.addEventListener(
      'click',
      function () {
        window.setTimeout(function () {
          var control = placeAppButton(slot);
          var added = true;
          if (control) {
            if (isAdded(control)) added = true;
            else if (/add to wishlist|加到願望|加入收藏/.test(textOf(control))) added = true;
            else added = !slot.classList.contains('is-active');
          }
          slot.classList.toggle('is-active', added);
          showToast(added);
        }, 250);
      },
      false
    );

    placeAppButton(slot);
    var n = 0;
    var timer = window.setInterval(function () {
      n += 1;
      placeAppButton(slot);
      if (n >= 40) window.clearInterval(timer);
    }, 300);

    var obs = new MutationObserver(function () {
      placeAppButton(slot);
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  ready(function () {
    document.querySelectorAll('.product-form__wishlist').forEach(wire);
  });
})();
